<script setup lang="ts">
import VueMarkdown from 'vue-markdown-render';

const props = defineProps<{
  hero: {
    title: string;
    description: string;
  };
  themeKeys: {
    bg: string;
    text: string;
  };
}>();
</script>

<template>
  <div
    class="outer-p-container"
    :style="{
      backgroundColor: props.themeKeys.bg,
      color: props.themeKeys.text
    }"
  >
    <div class="inner-container">
      <h1 class="text-4xl lg:text-5xl font-semibold mb-6 lg:mb-12 text-center w-4/5 mx-auto">{{ props.hero.title }}</h1>
      <p class="w-4/5 mx-auto mb-2 lg:mb-4">
        <VueMarkdown :source="props.hero.description" :options="{ html: true }" />
      </p>
    </div>
  </div>
</template>
